import {useStripe} from "@stripe/react-stripe-js";
import axios from "axios";
import {PaymentIntentResult} from "@stripe/stripe-js";
import {useTranslation} from "react-i18next";
import {mapApiError} from "../i18n/mapApiError";

export interface UsePaymentWithCardBody {
    amount: number,
    cardId: string,
    customerId?: string,
    description: string,
    country: string,
}

export const usePaymentWithCard = (): (body: UsePaymentWithCardBody, onSuccess: (id: string) => void, onError: (err: string) => void) => void => {
    const {t} = useTranslation('common')
    const stripe = useStripe()
    return (body: UsePaymentWithCardBody, onSuccess: (res?: any) => void, onError: (err: string) => void) => {
        if(body.amount > 0) {
            axios.post(`${process.env.REACT_APP_BART_URL}/stripe/create-payment`, body)
                .then(res => {
                    if (
                        res.data.status === 'requires_action' &&
                        res.data.nextAction &&
                        res.data.nextActionType === 'use_stripe_sdk'
                    ) {
                        // send the authentication request for 3d secure cards
                        stripe?.confirmCardPayment(res.data.clientSecret)
                            .then((response: PaymentIntentResult) => {
                                if(response.error) {
                                    onError(response.error.message || t('errors.cardGeneric'))
                                } else {
                                    onSuccess(response.paymentIntent.id);
                                }
                            })
                            .catch(() => {
                                onError(t('errors.cardGeneric'))
                            });
                    } else if(res.data.error) {
                        onError(res.data.error.message || t('errors.cardGeneric'))
                    } else {
                        onSuccess(res.data.id);
                    }
                })
                .catch(error => {
                    onError(mapApiError(error.response.data.message))
                });
        } else {
            onSuccess('')
        }
    };

}
